import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import NotFound from './components/NotFound';

// import Admin
import Login from './admin/components/Login';
import VerifyAccount from './admin/components/VerifyAccount';
import UsersPage from './admin/pages/UsersPage';
import AdminLayout from './admin/AdminLayout';
import Dashboard from './admin/pages/Dashboard';
import PropertiesPage from './admin/pages/PropertiesPage';
import AddPropertyPage from './admin/pages/AddPropertyPage';
import PropertyForm from './admin/components/PropertyForm';
import EditPropertyPage from './admin/pages/EditPropertyPage';
import ContactMessagesPage from './admin/pages/ContactMessagesPage';
import AppointmentsPage from './admin/pages/AppointmentsPage';
import ProfilePage from './admin/pages/ProfilePage';
import ReportsPage from './admin/pages/ReportsPage';
import SettingsPage from './admin/pages/SettingsPage';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Properties from './components/Properties';
import AboutUs from './components/AboutUs';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

// Componente para la página principal
const MainPage = () => {
  const [isTight, setIsTight] = React.useState(false);
  const wrapperRef = React.useRef(null);

  React.useEffect(() => {
    const handleScroll = () => {
      if (!wrapperRef.current) return;
      const rect = wrapperRef.current.getBoundingClientRect();
      setIsTight(rect.bottom <= window.innerHeight);
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleWrapperClick = () => {
    if (!isTight || !wrapperRef.current) return;
    const rect = wrapperRef.current.getBoundingClientRect();
    const absoluteBottom = rect.bottom + window.scrollY;
    window.scrollTo({ top: absoluteBottom - window.innerHeight, behavior: 'smooth' });
  };

  return (
    <div className="text-foreground font-sans antialiased">
      <Navbar />
      <div
        ref={wrapperRef}
        className={`page-wrapper${isTight ? ' tight' : ''}`}
        onClick={handleWrapperClick}
      >
        <Hero />
        <Properties />
        <AboutUs />
        <Contact />
      </div>
      <Footer revealed={isTight} />
    </div>
  );
};

function App() {
  return (
    <Router>
      <Routes>
        {/* Ruta principal */}
        <Route path="/" element={<MainPage />} />
        <Route path="/propiedad/:id" element={<MainPage />} />

        {/* Panel de administración */}
 <Route path="/admin" element={<AdminLayout />}>
  <Route index element={<Dashboard />} />
  <Route path="properties" element={<PropertiesPage />} />
  <Route path="properties/new" element={<PropertyForm  />} />
  <Route path="properties/edit/:id" element={<PropertyForm  />} />
  <Route path="agents" element={<div className="p-8"><h1 className="text-3xl font-bold">Agentes</h1><p>Próximamente</p></div>} />
  <Route path="appointments" element={<AppointmentsPage />} />
  <Route path="messages" element={<ContactMessagesPage />} />
  <Route path="reports" element={<ReportsPage />} />
  <Route path="settings" element={<SettingsPage />} />
  <Route path="users" element={<UsersPage />} />
  <Route path="profile" element={<ProfilePage />} />
</Route>

<Route path="/admin/login" element={<Login onLoginSuccess={() => window.location.href = '/admin'} />} />
        <Route path="/admin/verify" element={<VerifyAccount />} />
        
        {/* Ruta 404 - Redirige a inicio */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;